import store from '#/store';

export default function addInitialLoadRequiredRuleToRouter(router) {
  // performs initial load first time.
  router.beforeEach((to, from, next) => {
    if (store.getters.isInitialLoadComplete) {
      next();
    } else {
      console.log('router - detected need for initial load');
      store.dispatch('initialLoad').then(() => {
        console.log('router - initial load complete');
      }).catch((error) => {
        console.log('router - caught initial load error', error);
      }).finally(() => {
        next();
      });
    }
  });
}
